// @flow
const PLACEMENT_AUTO: 'auto' = 'auto';
const PLACEMENT_BOTTOM_END: 'bottom-end' = 'bottom-end';
const PLACEMENT_BOTTOM_START: 'bottom-start' = 'bottom-start';

export { PLACEMENT_AUTO, PLACEMENT_BOTTOM_END, PLACEMENT_BOTTOM_START };
